import { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Flex, Container, Heading } from 'theme-ui'
import { Nav, TableBySelect } from 'components'
import { GlobalCreateUserNotification, useAuth } from 'providers'
import getLocalized from 'i18n'
import { UserList } from 'components/UserList'
import { useList } from 'hooks/userHooks'
import { TEACHER_CREATED } from '../constants'
import * as access from 'types/access'

const localized = getLocalized()
export type ListTypes = 'tmatt' | 'student' | 'refresher'

export function Dashboard() {
  useEffect(() => {
    document.title = localized.documentTitles.adminDashboard
  }, [])
  const location = useLocation()
  const history = useHistory()
  const { profile, logout, hasAccess } = useAuth()
  const [isPageVisited, setPageVisited] = useState(false)
  const [activeList, setActiveList] = useState<ListTypes>('student')
  // Fetch student list on mount
  useEffect(() => {
    const isPageVisited = Boolean(localStorage.getItem(profile.email))
    setPageVisited(isPageVisited)
  }, [setPageVisited, profile.email])
  const isCustomerSupportUser = profile.groups.includes('SupportGroup')

  async function handleLogoutClick() {
    await logout(profile.email)
    history.push({
      pathname: '/',
      state: undefined,
    })
  }

  function handleFilterByTabChange(value: ListTypes) {
    setActiveList(value)
  }
  useEffect(() => {
    if (location.state === TEACHER_CREATED) {
      setActiveList('tmatt')
    }
  }, [location.state])

  const listParams = useList({
    type: activeList,
  })
  const list = listParams.list

  useEffect(() => {
    list({
      type: activeList,
      filters: undefined,
    })
  }, [list, activeList])

  const canCreateStudents =
    hasAccess(access.Groups.DASHBOARD, access.Dashboard.CREATE_TEST_USERS) ||
    hasAccess(access.Groups.DASHBOARD, access.Dashboard.CREATE_USERS)

  const canCreateTeachers = profile?.groups?.includes('SupportGroup')

  const canViewHelpCenter = hasAccess(
    access.Groups.DASHBOARD,
    access.Dashboard.VIEW_HELP_CENTER
  )

  return (
    <div data-cy="dashboard-screen">
      <Nav
        profile={profile}
        onLogoutClick={handleLogoutClick}
        access={{
          createStudent: canCreateStudents,
          createTeacher: canCreateTeachers,
          viewHelpCenter: canViewHelpCenter,
        }}
      />
      <Flex
        sx={{
          width: '100%',
          minHeight: 'calc(100vh - 90px)',
          flexDirection: 'column',
          alignItems: 'center',
          bg: 'whitesmoke',
        }}
      >
        <Container>
          <Flex sx={{ pt: 60, pb: 30, justifyContent: 'space-between' }}>
            {isCustomerSupportUser ? (
              <TableBySelect
                defaultValue={
                  location.state === TEACHER_CREATED ? 'tmatt' : 'student'
                }
                onSelectChange={handleFilterByTabChange}
              />
            ) : (
              <Heading>Students</Heading>
            )}
          </Flex>
          <UserList
            isPageVisited={isPageVisited}
            activeList={activeList}
            {...listParams}
          />
        </Container>
      </Flex>

      <GlobalCreateUserNotification />
    </div>
  )
}
